import { connect } from 'react-redux';
import { withStyles } from '@mui/styles';
import Storages from './Storages';
import styles from './styles';

function mapStateToProps(state) {
  const {
    isLoading, data, box, selectedBox, isLoadingDetails,
  } = state.box;
  return {
    isLoading,
    data,
    box,
    selected: selectedBox,
    isLoadingDetails,
  };
}

const Styled = withStyles(styles)(Storages);

export default connect(
  mapStateToProps,
)(Styled);
